/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 10:47:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-09 09:34:21
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\frequencySet.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { parseTime } from '@/utils/util'

export const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: '发布平台',
    dataIndex: 'project',
    align: 'left',
    width: 260,
    scopedSlots: { customRender: 'project' },
  },
  {
    title: '控制配置',
    dataIndex: 'control_type_t',
    align: 'left',
    width: 90,
    scopedSlots: { customRender: 'control_type_t' },
  },
  {
    title: '模块名称',
    dataIndex: 'module_name',
    align: 'left',
    width: 150,
    scopedSlots: { customRender: 'module_name' },
  },
  {
    title: '平台分类',
    dataIndex: 'platform',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'platform' },
  },
  {
    title: '标识',
    dataIndex: 'flag',
    width: 120,
    align: 'center',
  },
  {
    title: '类型',
    dataIndex: 'type_id',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'type_id' },
  },
  {
    title: '内容',
    dataIndex: 'contact',
    align: 'left',
    width: 160,
    scopedSlots: { customRender: 'contact' },
  },
  {
    title: '人员',
    dataIndex: 'user_id',
    align: 'left',
    width: 160,
    scopedSlots: { customRender: 'user_id' },
  },
  {
    title: '时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 185,
    scopedSlots: { customRender: 'create_at' },
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'center',
    width: 120,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    align: 'center',
    width: 100,
    fixed: 'right',
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' },
  },
]
export const columnsType = [
  {
    title: 'ID',
    dataIndex: 'id',
    width: 80,
    align: 'center',
  },
  {
    title: '类型名称',
    dataIndex: 'name',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '数据格式',
    dataIndex: 'format',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'format' },
  },
  {
    title: '创建人员',
    dataIndex: 'user_id',
    align: 'left',
    width: 120,
    scopedSlots: { customRender: 'user_id' },
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    align: 'left',
    width: 180,
    scopedSlots: { customRender: 'create_at' },
  },
  {
    title: '状态',
    dataIndex: 'status',
    align: 'left',
    width: 100,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    align: 'left',
    width: 100,
    // fixed: 'right',
    dataIndex: 'operator',
    scopedSlots: { customRender: 'operator' },
  },
]
export const searchForm = {
  line_id: undefined,
  popup_type: '',
  created_at: [],
  updated_at: [],
  created_name: '',
  updated_name: '',
  state: undefined,
}
export const searchFormType = {
  name: '',
  status: undefined,
}
